// FilteredPage.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

import { useNavigate, Link } from "react-router-dom";
import DataTable from 'react-data-table-component';
import Swal from "sweetalert2";
import { Pencil, Trash2, X, File, List,FileX, Calendar,Funnel, Upload, TicketCheck } from 'lucide-react';

import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import DateRangePicker from "../components/DateRangePicker"; 

export default function FilteredRf() {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const start = searchParams.get("start");
  const end = searchParams.get("end");
  const [pending, setPending] = useState(true);
  const [editEvent, setEditEvent] = useState(null);
  const [formData, setFormData] = useState({ name: '', client: '' , status: '' });
  const [searchText, setSearchText] = useState('');

  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const email = storedUser?.email;

  const NProgressSpinner = () => (
    <div style={{ padding: "1rem", textAlign: "center" }}>
      <div
        style={{
          boxSizing: "border-box",
          display: "block",
          width: "40px",
          height: "40px",
          border: "4px solid #29d",
          borderRadius: "50%",
          borderTopColor: "transparent",
          animation: "spin 0.6s linear infinite",
          margin: "0 auto 10px"
        }}
      ></div>
      <div>Memuat data, sabar yaa...</div>
    </div>
  );

  const [uploadTrfImage, setUploadTrfImage] = useState(null); 

  const [isOpen, setIsOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [file, setFile] = useState(null);
  const [showFilterTanggalExcel, setShowFilterTanggalExcel] = useState(false);

  useEffect(() => {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const email = storedUser?.email;
  
      fetch(`${process.env.REACT_APP_BASE_URL}api/users/search?email=${encodeURIComponent(email)}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setUser(data.data);
            console.log("Respon api search email:", data.data);
          } else {
            console.error(data.message);
          }
        })
        .catch((err) => console.error(err));
    }, []);
  
  const [showUploadTrf, setShowUploadTrf] = useState(false);

  const handleBuktiTrf = async (id) => {
    // Buka modal dulu supaya tidak delay
    setIsOpen(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/trfimage/${id}`);
      const result = await res.json();

      console.log("Respon api trfimage:", result.data);
      // Misal API mengembalikan { image: "https://example.com/img.jpg" }
      setFileData(result.data);
    } catch (err) {
      console.error("Gagal ambil gambar:", err);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleUpload = (id) => {
    setSelectedId(id); // simpan ID
    setShowUploadTrf({ name: id.name, id_rf : id }); // tampilkan modal
  };

  const [formTrfImage, setFormTrfImage] = useState(null);
  
    const [statusRead, setStatusRead] = useState({ trf: '1'});
    
    const [selectedId, setSelectedId] = useState(null);
  
    const handleUploadTrfImage = async (e) => {
      e.preventDefault();
  
      // Cek kalau belum pilih file
      if (!file) {
        alert("Silakan pilih file terlebih dahulu.");
        return;
      }
      // Siapkan FormData
      const formData = new FormData();
      formData.append("file", file);       
      formData.append("id", selectedId);     
      formData.append("upload_by", email);   
  
      try {
        const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/trfimage/savefile`, {
          method: "POST",
          body: formData, // penting: FormData langsung, tanpa headers 'Content-Type'
        });
  
        const result = await res.json();
  
        if (res.ok && result.status === "success") {
          fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${selectedId}`, {
              method: 'PUT',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(statusRead),
          })
          Swal.fire('Terupload!', 'Bukti trf berhasil terupload', 'success');
          setShowUploadTrf(false); // Tutup modal
          setFile(null);           // Reset file
        } else {
          alert(result.message || "Gagal upload file");
        }
      } catch (error) {
        console.error("Error upload:", error);
        alert("Terjadi kesalahan saat upload");
      }
    };

  useEffect(() => {
    if (start && end) {
      fetchData(start, end);
    }
  }, [start, end]); // <--- Tambahkan dependency agar fetch dipanggil ulang saat tanggal berubah

  const fetchData = (startDate, endDate) => {
    setPending(true); // tampilkan loading jika mau

    fetch(`${process.env.REACT_APP_BASE_URL}api/filtered?start=${startDate}&end=${endDate}`)
      .then((res) => res.json())
      .then((result) => {
        setData(result.data || []);
        setPending(false);
      })
      .catch((err) => {
        console.error('Gagal ambil data:', err);
        setPending(false);
      });
  };

  const filteredData = data.filter((item) =>
  item.pic.toLowerCase().includes(searchText.toLowerCase())||
  item.event.toLowerCase().includes(searchText.toLowerCase())||
  item.vendor.toLowerCase().includes(searchText.toLowerCase())||
  item.note.toLowerCase().includes(searchText.toLowerCase())||
  item.input_date.toLowerCase().includes(searchText.toLowerCase())
  );

  const handleEdit = (event) => {
    setEditEvent(event);
    setFormData({ name: event.name, client: event.client, status:event.status });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Yakin hapus ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire('Terhapus!', 'Data berhasil dihapus.', 'success');
              navigate(`/rf`);
          });
      }
    });
  };

  const handleTrf = (id) => {
      Swal.fire({
        title: 'Ajuan ini sudah transfer?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3c30e9ff',
        cancelButtonColor: '#e9303fff',
        confirmButtonText: 'Ya, sudah',
        cancelButtonText: 'Batal',
      }).then((result) => {
        if (result.isConfirmed) {
          fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ trf: 1, read:"read", trf_by:email }),
          })
            .then((res) => res.json())
            .then(() => {
              Swal.fire('Berhasil!', 'Status berubah menjadi sudah transfer.', 'success');
              navigate(`/rf`);
            });
        }
      });
    }

  const fileUrl = fileData?.name ?`${process.env.REACT_APP_BASE_URL}/uploads/${fileData.name}` : null;

  const isPDF = fileData?.name?.toLowerCase().endsWith(".pdf");

  const columns = [
      
      {
        name: 'Tanggal',
        selector: row => new Date(row.tanggal_final),
        sortable: true,
        cell: row => {
          const date = format(new Date(row.tanggal_final), "dd MMM yyyy");
          const time = format(new Date(row.tanggal_final), "H:mm");
          return (
            <div>
              {date}
              <br />
              {time}
            </div>
          );
        },
        width: "12%"
      },
      {
        name: 'Keterangan',
        selector: row => row.note,
        sortable: true,
        wrap: true,
        width: "25%",
      },
      {
        name: 'Vendor',
        selector: row => row.vendor,
        sortable: true,
        wrap: true,
        width: "13%",
      },
      {
        name: 'Event',
        selector: row => row.event,
        sortable: true,
        wrap: true,
        wrap: true,
        width: "10%",
      },
      {
        name: 'PIC',
        selector: row => row.pic,
        sortable: true,
        wrap: true,
        width: "10%",
      },
      {
        name: 'Status',
        cell: (row)=>(
          <div>
            <span
              className={`px-2 py-1 text-xs rounded-full ${
                row.trf == 1
                  ? 'bg-green-100 text-green-700'
                  : row.read === "read"
                    ? 'bg-purple-100 text-purple-700'
                    : 'bg-red-100 text-red-700'
              }`}
            >
              {
                row.trf == 1
                  ? 'Sudah Transfer'
                  : row.read === "read"
                    ? 'Sudah Print'
                    : 'Belum Print'
              }
            </span>
          </div>
        ),
        width: "10%",
      },
      {
        name: 'Total',
        cell: (row) => (
          <span
            className={`px-2 py-1 text-xs font-semibold rounded-full ${
              row.trf === "1"
                ? 'bg-green-100 text-green-700'
                : 'bg-red-100 text-red-700'
            }`}
          >
            {new Intl.NumberFormat('id-ID', {
              style: 'currency',
              currency: 'IDR',
              minimumFractionDigits: 0,
            }).format(row.total)}
          </span>
        ),
        ignoreRowClick: true,
        width: "10%",
      },
    ];

  if (["1"].includes(user?.group_id ?? "")){
    columns.push({
      name: 'Aksi',
      cell: (row) => (
        <div className="flex gap-1">
          <button
            className="bg-yellow-300 hover:bg-yellow-500 text-white p-1 rounded"
            onClick={() => handleEdit(row.id)}
          >
            <Pencil size={14} />
          </button>
          <button
            className="bg-green-400 hover:bg-green-600 text-white p-1 rounded"
            onClick={() => handleTrf(row.id)}
          >
            <TicketCheck size={14} />
          </button>          
          <button
            className="bg-red-400 hover:bg-red-600 text-white p-1 rounded"
            onClick={() => handleDelete(row.id)}
          >
            <Trash2 size={14} />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      width: "10%"
    });
  }
  
  if (["2"].includes(user?.group_id ?? "")){
    columns.push({
      name: 'Aksi',
      cell: (row) => (
        <div className="flex gap-1">        
          <button
            className="bg-yellow-300 hover:bg-yellow-500 text-white p-1 rounded"
            onClick={() => handleEdit(row.id)}
          >
            <Pencil size={14} />
          </button>
          <button
            className="bg-green-400 hover:bg-green-600 text-white p-1 rounded"
            onClick={() => handleTrf(row.id)}
          >
            <TicketCheck size={14} />
          </button>  
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      width: "10%"
    });
  }

  const customStyles = {
    table: {
      style: {
        // borderRadius: '15px', //rounded nya
        // border: '1px solid #ccc',
        overflow: 'hidden',  
      },
    },
    headRow: {
      style: {
        fontWeight: 'bold',
        borderRight: '0.5px solid #ccc',  
        color: '#111827', 
        fontSize: '16px',
      },
    },
    headCells: {
      style: {
        borderLeft: '0.5px solid #ccc', 
        padding: '8px'
      },
    },
    rows: {
      style: {
        // border: '1px solid #ccc',
        borderRight: '0.5px solid #ccc',   
        fontSize: '16px',
        
      },
    },
    cells: {
      style: {
        // border: '0.5px solid #ccc',
        borderLeft: '0.5px solid #ccc',   
        padding: '8px'
      },
    },
  };
  
  const formatDate = (date) => {
    return new Date(date).toISOString().split("T")[0];
  };

  const handleSubmitExport = (e) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      alert("Pilih tanggal terlebih dahulu!");
      return;
    }
    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    window.location.href = `${process.env.REACT_APP_BASE_URL}export/filteredRf?start=${formattedStart}&end=${formattedEnd}`;
  };

  return (
        <div className="flex bg-white p-5 rounded-lg shadow-lg w-full">
      <div className="p-2 w-full">
        <div className="flex justify-between bg-gray-800 flex-wrap gap-2 p-4 mb-2">
          <div className="flex gap-2">
            {(["1", "3"].includes(user?.group_id ?? "")) && (
              <Link
                to="/create"
                className="flex items-center gap-2 bg-white hover:bg-white/50 text-black px-2 py-2 rounded text-md"
              >
                <File size={16} />
                Buat Form Ajuan
              </Link>
            )}
            <Link to="/rf">
              <button type="button" to="/rf" className="flex items-center bg-blue-600 hover:bg-blue-700 text-white px-2 py-2 gap-2 rounded shadow text-md">
                <List size={30} /> Tampilkan semua
              </button>
            </Link>
            <button type="button"
              onClick={() => setShowModal(true)} className="flex items-center border border-rose-700 bg-rose-500 hover:bg-rose-400 text-white px-2 py-2 gap-2 rounded shadow text-md">
              <Calendar size={30} /> Filter Tanggal
            </button>
            {(["1", "2"].includes(user?.group_id ?? "")) && (
              <button type="button"
                onClick={() => setShowFilterTanggalExcel(true)} className="flex items-center border border-green-300 bg-green-500 hover:bg-green-700 text-green-700 px-2 py-2 gap-2 rounded shadow text-md text-white ">
                <FileX size={16} /> Export ke Excel
              </button>
            )}
          </div>
          <div className="flex gap-2 justify-between">
            <input
              type="text"
              placeholder="Pencarian..."
              className="border border-gray-300 px-2 py-2 rounded text-md"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </div>
        <DataTable
        columns={columns}
        data={filteredData}
        pagination
        responsive
        progressPending={pending}
        progressComponent={<NProgressSpinner  />}
        highlightOnHover
        striped
        fixedHeader
        customStyles={customStyles}
        conditionalRowStyles={[
          {
            when: row => row.read === "unread",
            style: {
              fontWeight: "bold"
            },
          }]}
        onRowClicked={row => {
          const url = `/v2/detail/${row.id}`;
          window.open(url, "_blank");
        }}
        />
      </div>
      {showUploadTrf && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg p-4 max-w-3xl w-full relative">
            <button
              className="absolute top-2 right-2 text-gray-500"
              onClick={() => {
                setShowUploadTrf(false);
              }}
            >
              ✕
            </button>

            <h2 className="text-lg font-bold mb-4">Upload Bukti Transfer </h2>
            <form onSubmit={handleUploadTrfImage} className="space-y-4">
              <div>
                <label className="block font-medium">File</label>
                <input
                  type="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  className="w-full border p-2 rounded"
                />
                <input
                  type="hidden"
                  value={selectedId}
                  className="border p-2 w-full mb-4"
                  readOnly // jika mau hanya bisa dibaca
                />
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-300 rounded"
                  onClick={() => setShowUploadTrf(false)}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-black/100 text-white rounded hover:bg-black/70"
                >
                  Simpan
                </button>
              </div>
            </form> 
            
          </div>
        </div>
      )}
      {showFilterTanggalExcel && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <form className="space-y-4">
            <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
              <h3 className="text-lg font-bold mb-4">Filter Tanggal Export ke Excel</h3>

              {/* Komponen DateRange */}
              <DateRangePicker
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
              />

              <div className="flex justify-end gap-2 mt-6">
                <button
                  onClick={() => setShowFilterTanggalExcel(false)}
                  className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                >
                  Batal
                </button>
                <button
                  onClick={handleSubmitExport}
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
                >
                  Terapkan
                </button>
              </div>
            </div>
            </form>
        </div>
      )}
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg p-4 max-w-3xl w-full relative">
            <button
              className="absolute top-2 right-2 text-gray-500"
              onClick={() => {
                setIsOpen(false);
                setFileData(null);
              }}
            >
              ✕
            </button>

            <h2 className="text-lg font-bold mb-4">File Bukti Transfer</h2>

            {!fileData ? (
              <p className="text-gray-500">File tidak ditemukan</p>
            ): fileData.data === null ? (
              <p className="text-red-500">File tidak ditemukan</p>
            ) : isPDF ? (
              <iframe
                src={fileUrl}
                className="w-full h-[500px]"
                title="PDF Viewer"
              />
            ) : (
              <img src={fileUrl} alt="Preview" className="w-full rounded" />
            )}
          </div>
        </div>
      )}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <form className="space-y-4">
            <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
              <h3 className="text-lg font-bold mb-4">Filter Tanggal</h3>

              {/* Komponen DateRange */}
              <DateRangePicker
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
              />

              <div className="flex justify-end gap-2 mt-6">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                >
                  Batal
                </button>
                <button
                  onClick={() => {
                    const start = startDate ? format(startDate, "yyyy-MM-dd") : "";
                    const end = endDate ? format(endDate, "yyyy-MM-dd") : "";
                    setShowModal(false);
                    navigate(`/filteredRf?start=${start}&end=${end}`);
                    setShowModal(false);                    
                  }}
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
                >
                  Terapkan
                </button>
              </div>
            </div>
            </form>
        </div>
      )}
    </div> 
  );
}
